export default __webpack_public_path__ + "static/media/my-score-star.5bcb347a.svg";